export function Footer({ inset }: { inset?: boolean }) {
  return (
    <footer
      className={`flex flex-shrink-0 items-center justify-center px-4 py-3 text-2xs text-zinc-500 ${
        inset ? "" : "border-t border-white/60"
      }`}
    >
      <p>
        Copyright &copy; BT4Team{" "}
        <a
          href="https://bt4team.com"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-zinc-700 underline decoration-zinc-300 underline-offset-2 transition-colors hover:text-zinc-900 hover:decoration-zinc-500"
        >
          bt4team.com
        </a>
      </p>
    </footer>
  );
}
